import { apiRequest } from "./apiClient";

export function listAuditLogs({ page = 0, size = 20 } = {}) {
  const safePage = Math.max(0, Number(page) || 0);
  const safeSize = Math.min(100, Math.max(1, Number(size) || 20));
  return apiRequest(`/api/audit-logs?page=${safePage}&size=${safeSize}`);
}
